import { RefStatut } from './statut.ref.model';
import { HabilitationStatutWorkflow } from './habilitation-statut-workflow';
import { ArrayClassConverterFactory } from '../../../core/services/mapper/data-property.converter';

export class References {
    static jsonMap = {
        statutsHabilitation: { key: 'statutHabilitationReferences', converter: new (ArrayClassConverterFactory.build(RefStatut))() },
        statutsHabilitationWorkflow: { key: 'statutsHabilitationWorkflows', converter: new (ArrayClassConverterFactory.build(HabilitationStatutWorkflow))() }
    };

    public statutsHabilitation: RefStatut[] = [];
    public statutsHabilitationWorkflow: HabilitationStatutWorkflow[] = [];
}
